import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Container,
  Form,
  Header,
  Icon,
  List,
  Message,
  Modal,
  Segment
} from 'semantic-ui-react';
import facebookLogo from "../../components/Layout/facebook.png";
import instagramLogo from "../../components/Layout/instagram.png";
import draxLogo from "../../components/Layout/logo2.png";
import naverLogo from "../../components/Layout/naver.png";

const WarrantyInfo = () => {
  const navigate = useNavigate();
  const [isAgreed, setIsAgreed] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  // 접수 페이지 공지 (2026-09-15): 첫 화면이 아니라 '고장접수' 다음 화면(출장서비스 안내)에서 띄운다.
  // Django /receiption/api/notice/ 의 게시 중 공지(최대 5개). 우상단 X 로만 닫히고, 같은 탭 세션에서는 다시 띄우지 않는다.
  type Notice = { id: number; title: string; content: string; level: string; updated_at: string };
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  const NOTICE_KEY = 'asNoticeDismissed';
  const [notices, setNotices] = useState<Notice[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    let seen: number[] = [];
    try { seen = JSON.parse(sessionStorage.getItem(NOTICE_KEY) || '[]'); } catch (e) { seen = []; }
    axios.get(`${apiEndpoint}/receiption/api/notice/`, { timeout: 5000 })
      .then((res) => {
        const list: Notice[] = (res.data && res.data.notices) || [];
        const fresh = list.filter((n) => seen.indexOf(n.id) < 0);
        if (fresh.length) { setNotices(fresh); setIsOpen(true); }
      })
      .catch(() => { /* 공지 API 실패 시 아무것도 띄우지 않음 */ });
  }, [apiEndpoint]);
  const closeNotice = () => {
    try {
      const seen: number[] = JSON.parse(sessionStorage.getItem(NOTICE_KEY) || '[]');
      sessionStorage.setItem(NOTICE_KEY, JSON.stringify(seen.concat(notices.map((n) => n.id))));
    } catch (e) { /* ignore */ }
    setIsOpen(false);
  };
  const LEVEL_COLOR: Record<string, string> = { info: '#0D47A1', warn: '#7A4F01', urgent: '#B71C1C' };
  const LEVEL_BG: Record<string, string> = { info: '#E3F2FD', warn: '#FFF8E1', urgent: '#FDECEA' };
  const topLevel = notices.reduce((a, n) => ({ urgent: 3, warn: 2, info: 1 }[n.level] || 1) > ({ urgent: 3, warn: 2, info: 1 }[a] || 1) ? n.level : a, 'info');

  const handleAgreeChange = (e: React.FormEvent<HTMLInputElement>, data: any) => {
    setIsAgreed(data.checked);
  };

  const handleNavigate = () => {
    if (isAgreed) {
      navigate('/customer');
    }
  };


  return <>
  (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div
        ref={contentRef}
        style={{
          flex: 1,
          maxWidth: '600px',
          padding: '20px',
          paddingBottom: '100px'
        }}
      >
        <Container>
          <Header as='h1' textAlign='center' style={{marginTop: '1em', }}>
            출장서비스 안내
          </Header>
          <div className="ui divider"></div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              marginBottom: '30px',
              marginTop: '2em'
            }}>
              <img src={require("./procedure.png")} alt="Drax" className="py-1" style={{ width: '80%', height: 'auto' }}/>
            </div>

          <Segment style={{ marginBottom: '1em' }}>
            <Header as='h3' textAlign='center'>
              서비스 요금 선정 기준
            </Header>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}>
                <img src={require("./price_calc.png")} alt="Drax" className="py-1" style={{ width: '85%', height: 'auto', }}/>
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '0 20px'
            }}>
              <div style={{marginTop: '20px'}}>
                <div style={{marginBottom: '10px'}}>
                  <strong>* 부품비</strong> : 부품비는 제품을 수리하는 데 <span style={{backgroundColor: '#fff3cd', padding: '0 4px'}}>부품 교체를 할 경우 소요되는 부품의 가격</span>을 말합니다.
                </div>
                <div style={{marginBottom: '10px'}}>
                  <strong>* 공임비</strong> : 공임비는 제품을 수리하는 데 필요한 <span style={{backgroundColor: '#fff3cd', padding: '0 4px'}}>수리 난이도 및 시간에 따른 순수 기술료</span>를 말합니다.
                </div>
                <div>
                  <strong>* 출장비</strong> : 출장비는 <span style={{backgroundColor: '#fff3cd', padding: '0 4px'}}>출장수리 시 징수</span>하며 징수 금액은 <span style={{backgroundColor: '#fff3cd', padding: '0 4px'}}>44,000원(VAT포함)</span> 입니다.
                </div>
                <div>
                <Message warning color='red' style={{marginTop: '10px'}}>
                  <Icon size="large" name='warning sign'/><span style={{ fontSize: '1.5rem'}}><strong>알림</strong></span>
                  <p>* <strong>유상수리제품</strong>은 <strong>수리내용과 상관없이 출장비가 발생</strong>됩니다.</p>
                </Message>
                </div>
              </div>
            </div>
          </Segment>
          <Segment>
            <Header as='h3' textAlign='center'>유/무상 서비스 구분 기준</Header>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '0 20px'
            }}>
              <div style={{marginBottom: '20px'}}>
                <Header as='h4' style={{marginBottom: '5px'}}>(무상서비스)</Header>
                <p><strong>보증기간 이내</strong>에 <strong>정상적인 사용 상태</strong>에서 발생한 성능, 기능상의 고장</p>
              </div>

              <div style={{marginBottom: '20px'}}>
                <Header as='h4' style={{marginBottom: '5px'}}>(유상서비스)</Header>
                <List bulleted style={{marginTop: '5px'}}>
                    <List.Item><strong>사고 또는 천재지변</strong>으로 인하여 발생한 고장</List.Item>
                    <List.Item><strong>고객의 취급 부주의 또는 잘못된 사용방법</strong>으로 인한 고장</List.Item>
                    <List.Item><strong>당사의 A/S 기사 및 대리점 전문 기사 이외의 사람이 수리 또는 개조</strong>를 실시하여 발생된 고장</List.Item>
                    <List.Item><strong>증여 받거나 또는 중고로 구입</strong>한 제품에서 발생된 고장</List.Item>
                    <List.Item><strong>소비자가 분실한 각종 부품들</strong>에 대한 요청이 있는 경우</List.Item>
                    <List.Item><strong>가정용 제품을 상업용으로 사용</strong>하여 발생된 고장</List.Item>
                    <List.Item>무상 보증기간내인 경우라도 <strong>수명이 다한 부품(소모성부품)</strong>의 교체가 필요한 경우</List.Item>
                    <List.Item><strong>자가점검사항(장력조절, 오일주입 등)을 요청</strong>하는 경우 </List.Item>
                </List>

                <Message warning size='small'>
                    <p>* 특히, <strong>고객 또는 제 3자가 당사가 제공하지 않는 부품을 부착, 사용하거나, 당사의 허가 없이 제품을 개조, 변경한 경우, 수리 거절</strong>의 사유가 될 수 있습니다.</p>
                </Message>
              </div>

              <div>
                <Header as='h5' style={{marginBottom: '5px'}}>(예외사항)</Header>
                <List style={{marginLeft: '10px', marginTop: '5px'}}>
                    <List.Item style={{lineHeight: '1.3'}}>* <strong>부품보증</strong>은 제품을 구성하는 각 부품에 대한 품질 보증을 말하며 그 기간은 다음과 같습니다.</List.Item>
                    <List.Item style={{lineHeight: '1.3'}}>* <strong>유상으로 수리한 경우</strong>, 수리한 날부터 <strong>6개월 이내</strong>에 정상적으로 제품을 사용하는 과정에서 <strong>종전과 동일한 부품 고장이 재발한 경우 무상수리</strong> (일반적 소비자분쟁해결기준 및 내규)</List.Item>
                </List>
              </div>
            </div>
          </Segment>
          <Segment>
            <Header as='h3' textAlign='center'>보증기간 산정기준</Header>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '0 20px'
            }}>
                <div style={{marginBottom: '20px'}}>
                    <table style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd', textAlign: 'center'}}>
                        <thead>
                            <tr style={{backgroundColor: '#fff3cd'}}>
                                <th style={{border: '1px solid #ddd', padding: '8px', width: '40%'}}>모델</th>
                                <th style={{border: '1px solid #ddd', padding: '8px', width: '30%'}}>보증기간</th>
                                <th style={{border: '1px solid #ddd', padding: '8px', width: '30%'}}>출장비</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>NR시리즈</td>
                                <td rowSpan={12} style={{border: '1px solid #ddd', padding: '8px'}}>구입일로부터 1년</td>
                                <td rowSpan={11} style={{border: '1px solid #ddd', padding: '8px'}}>44,000원(VAT포함)</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>마이마운틴</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>RX시리즈</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>무동력 트레드밀</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>스테어클라이머</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>좌식바이크</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>입식바이크</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>일립티컬</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>웨이트</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>퓨어플레이트</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>프리웨이트</td>
                            </tr>
                            <tr>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>카이저</td>
                                <td style={{border: '1px solid #ddd', padding: '8px'}}>55,000원(VAT포함)</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style={{marginBottom: '20px'}}>
                    <List bulleted style={{marginTop: '5px'}}>
                        <List.Item><strong>제품 보증기간</strong>은 제조사 또는 제품 판매자가 소비자에게 <strong>정상적인 상태에서 자연 발생한 품질, 성능, 기능 하자</strong>에 대하여 <strong>무료수리</strong>를 해주겠다고 약속한 기간을 말합니다.</List.Item>
                        <List.Item>제품 보증기간은 <strong>구입일자</strong>를 기준으로 산정하며 구입일자의 확인은 <strong>제품설치확인서</strong>를 기준으로 합니다. 단 제품설치확인서가 없는 경우는 <strong>제조년월</strong>로 보증기간을 계산합니다.</List.Item>
                        <List.Item><strong>중고 제품(중고 헬스기구 매매 업자를 통한 구매 포함)</strong> 구입 시 보증기간은 적용되지 않으며, <strong>수리 불가의 경우 피해보상을 책임지지 않습니다.</strong></List.Item>
                        <List.Item>당사와의 <strong>계약을 통해 납품되는 제품</strong>의 보증은 그 <strong>계약내용</strong>을 기준으로 합니다.</List.Item>
                    </List>
                </div>
            </div>
          </Segment>
          <Segment>
          <Header as='h3' textAlign='center'>제품 유지 보수</Header>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '0 20px'
            }}>
              <div style={{marginBottom: '20px'}}>
                <List bulleted style={{marginTop: '5px'}}>
                    <List.Item><strong>제품 및 사용자의 안전</strong>은 <strong>사용자의 정기적인 관리</strong>가 유지되어야만 보장 받을 수 있습니다.</List.Item>
                    <List.Item><strong>제품관리 일정표</strong>를 참고하여 <strong>제품의 관리 및 고장 예방</strong>을 위해 행동하십시오</List.Item>
                </List>

                <div
                  style={{
                    cursor: 'pointer',
                    color: '#2185d0',
                    textDecoration: 'underline',
                    marginTop: '10px',
                    textAlign: 'center',
                    fontSize: '1.5rem',
                    fontWeight: 500
                  }}
                  onClick={() => window.open('solutions/9', '_blank')}
                >
                  제품관리 일정표 바로가기
                </div>

                <Message color='red' size='large' style={{marginTop: '10px'}}>
                  <Icon size="large" name='warning sign'/><span style={{ fontSize: '1.5rem'}}><strong>알림</strong></span>
                    <p>제품을 <strong>정기적으로 유지관리</strong> 해야만 <strong>사용자의 안전과 제품의 상태가 보장</strong>됩니다. 부품에 결함이 있을 경우, 제품을 수리하거나 교체할 때 까지 <strong>절대</strong> 사용하지 마십시오.</p>
                </Message>
              </div>
            </div>

          </Segment>
        </Container>
        {/* footer */}
        <div className="ui divider"/>
        <div className="information2 row" style={{ display: "flex" }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: '0',
              paddingTop: '0',
              paddingBottom: '1rem'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
              <div style={{ flex: '0 0 80%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%' }}>
                <img
                  src={draxLogo}
                  alt="Drax"
                  className="py-1"
                  style={{ width: '100%', height: 'auto', maxWidth: '200px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.draxfit.com/', '_blank')}
                />
              </div>
              <div style={{ flex: '0 0 20%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20%' }}>
                <img
                  src={naverLogo}
                  alt="Naver"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://blog.naver.com/draxfit_official/', '_blank')}
                />
                <img
                  src={instagramLogo}
                  alt="Instagram"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.instagram.com/draxfit_official/', '_blank')}
                />
                <img
                  src={facebookLogo}
                  alt="Facebook"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.facebook.com/DRAXFIT/', '_blank')}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50%",
              textAlign: 'left',
              fontSize: '0.75rem',
              paddingBottom: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <div style={{ fontWeight: 'bold', fontSize: '1.5rem', marginBottom: '8px' , marginTop: '27px'}}>주식회사 디랙스</div>
            <div style={{ marginBottom: '0.5px' }}>본사/제1공장 : 경기 안양시 만안구 전파로62번길 26</div>
            <div style={{ marginBottom: '0.5px' }}>제2공장 : 경기 안양시 만안구 전파로 48</div>
            <div style={{ marginBottom: '0.5px' }}>제3공장 : 경기 안양시 만안구 덕천로72번길 85</div>
            <div style={{ marginBottom: '0.5px' }}>사업자등록번호 123-81-70002</div>
            <div style={{ marginBottom: '0.5px' }}>TEL: 031-459-8530 / FAX: 031-459-8531</div>
          </div>
        </div>
        {/* footer */}
      </div>
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '20px',
        backgroundColor: 'white',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center'
      }}>
        <Form>
          <Form.Checkbox
            label='위 내용을 모두 확인하였으며, 이후 진행되는 내용에 동의합니다.'
            checked={isAgreed}
            onChange={handleAgreeChange}
          />
        </Form>
        <Button
          primary
          size='large'
          disabled={!isAgreed}
          onClick={handleNavigate}
        >
          고객 접수 페이지로 이동
        </Button>
      </div>

    </div>

    {/* 접수 페이지 공지 팝업 (2026-09-15): 우상단 X 로만 닫힘 — 배경 클릭·ESC 로는 안 닫힘 */}
    <Modal
      open={isOpen}
      onClose={closeNotice}
      size="small"
      closeIcon
      closeOnDimmerClick={false}
      closeOnEscape={false}
    >
      <Modal.Header style={{ background: LEVEL_BG[topLevel] || LEVEL_BG.info, color: LEVEL_COLOR[topLevel] || LEVEL_COLOR.info }}>공지사항</Modal.Header>
      <Modal.Content scrolling>
        {notices.map((n, idx) => (
          <div key={n.id} className="as-notice-item" style={idx > 0 ? { marginTop: '16px', paddingTop: '16px', borderTop: '1px dashed #bbb' } : {}}>
            {n.title && <div className="as-notice-title" style={{ color: LEVEL_COLOR[n.level] || LEVEL_COLOR.info }}>{n.title}</div>}
            {/* content 는 서버(bleach)가 정화한 HTML — 표·굵게·목록·이미지 */}
            <div className="as-notice-content" dangerouslySetInnerHTML={{ __html: n.content || '' }} />
          </div>
        ))}
        <div className="as-notice-foot">오른쪽 위 × 를 누르면 접수 화면으로 넘어갑니다.</div>
      </Modal.Content>
    </Modal>
    );
  </>
};

export default WarrantyInfo;